import { dispatchStoreEvent, storeEvents } from "../store/store.events.js";
import type { ProxyTarget, TargetStore } from "../store/store.types.js";

import { createProxy } from "../proxy/proxy.js";
import { configSync } from "../proxy/proxyConfig.js";
import type { AssignOptions, Unset } from "../proxy/proxy.types.js";

import { assertFunction, assertNamespaceFree } from "../utils/utils.js";
import type { AnyFunction } from "../utils/utils.types.js";

import {
  assignMembers,
  cleanupStore,
  eventMembers,
  removeTargetProps,
  setupReady,
  setupTargetProps,
} from "../store/store.js";

import { invokeHandlerAsync } from "./private.js";

/**
 *
 *
 *
 *
 *
 *
 */
export function unsetFunction(
  store: TargetStore,
  target: ProxyTarget,
  handler: AnyFunction,
): boolean {
  const res = store.handler === handler;

  /*                            */
  if (!res) return res;

  cleanupStore(store, target);
  setupReady(store);
  setupTargetProps(target, ...eventMembers, ...assignMembers);
  store.log.debug("Unset function handler", handler);
  dispatchStoreEvent(store, storeEvents[3], { type: storeEvents[3], path: store.path, handler });

  return res;
}

/**
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function assignFunction(
  store: TargetStore,
  target: ProxyTarget,
  handler: AnyFunction,
  options?: AssignOptions,
): Unset {
  assertFunction(store, handler);
  assertNamespaceFree(store, "set handler to", options);
  cleanupStore(store, target, { fn: true });

  store.isFunc = true;
  removeTargetProps(target, ...eventMembers, ...assignMembers);
  store.handler = handler as AnyFunction;
  store.onReady(createProxy(target, configSync));

  /*                                            */
  if (options?.clean) store.invocations.splice(0);

  /*                                */
  store.invocations.splice(0).forEach(invokeHandlerAsync, store);
  store.log.debug("Assign function handler", handler);
  dispatchStoreEvent(store, storeEvents[2], { type: storeEvents[2], path: store.path, handler });

  /*                    */
  return unsetFunction.bind(undefined, store, target, handler);
}
